import React, { DetailedHTMLProps, ImgHTMLAttributes } from "react"
import classnames from "classnames"
import * as styles from "./Image.module.css"

const Image = ({
  src: SRC,
  height,
  width,
  hasCut,
  style,
  fitMobile,
  ...props
}: {
  src: string
  width?: number
  height?: number
  svg?: boolean
  hasCut?: boolean
  style: React.CSSProperties
  fitMobile?: boolean
} & DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>) => {
  return (
    <div
      style={{
        width,
        height,
        clipPath: hasCut ? "polygon(27% 0%, 100% 0%, 100% 100%, 0% 100%)" : "",

        overflow: "hidden",
        ...style,
      }}
      className={classnames(styles.ImageContainer, {
        [styles.fitMobile]: fitMobile,
        [styles.hasCut]: hasCut,
      })}
    >
      {hasCut && <span className={styles.borderRight} />}
      {hasCut && <span className={styles.borderTop} />}
      {hasCut && <span className={styles.borderBottom} />}
      <img {...props} src={SRC} className={styles.mdImage} />
    </div>
  )
}

export default Image
